import { DownOutlined, UpOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import cn from 'classnames';
import { useState } from 'react';

import type { FC, ReactNode } from 'react';

import '@app/shared/components/FiltersAccordion/FiltersAccordion.scss';

// `mobile` collapses the filters at the global mobile threshold (default,
// used across the app). `tablet` is an opt-in wider threshold (800px) used by
// registries whose filter set is too dense to stay inline on tablets.
type FiltersAccordionBreakpoint = 'mobile' | 'tablet';

interface FiltersAccordionProps {
  children: ReactNode;
  breakpoint?: FiltersAccordionBreakpoint;
}

export const FiltersAccordion: FC<FiltersAccordionProps> = ({
  children,
  breakpoint = 'mobile',
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div
      className={cn('filters-accordion', {
        'filters-accordion--tablet': breakpoint === 'tablet',
      })}
    >
      <Button
        className="filters-accordion__toggle"
        icon={isOpen ? <UpOutlined /> : <DownOutlined />}
        onClick={() => setIsOpen((prev) => !prev)}
        block
      >
        {isOpen ? 'Свернуть фильтры' : 'Развернуть фильтры'}
      </Button>
      <div
        className={cn('filters-accordion__content', {
          'filters-accordion__content--open': isOpen,
        })}
      >
        {children}
      </div>
    </div>
  );
};
